import { LocalDate } from "../../../../core/pojo/date-variable";

export class CreatorFolderForMetricDataRs {
  metricDataUUID: string;
  boxFolderId: string;

  constructor(metricDataUUID: string, boxFolderId: string) {
    this.metricDataUUID = metricDataUUID;
    this.boxFolderId = boxFolderId;
  }
}

export interface KpiSharedLinkParams {
  token: string;
  password: string;
}

export class FileDeletionMetricData {
  metricDataUUID: string;
  boxFileID: string;
  companyUUID: string;
  fileName: string;

  constructor(metricDataUUID: string, boxFileID: string, companyUUID: string, fileName: string) {
    this.metricDataUUID = metricDataUUID;
    this.boxFileID = boxFileID;
    this.companyUUID = companyUUID;
    this.fileName = fileName;
  }
}

export class KpiModalDocumentCrudWrapper {
  constructor(
    public companyUUID: string,
    public metricDataUUID: string,
    public boxFolderId: string,
    public period: LocalDate,
    public metricName: string,
    public isPeriodRequested: boolean,
    public isUploadBoxOnStartNeeded: boolean,
  ) {}
}
